import {gql} from '@apollo/client'

export default gql`
  {
    allUsers {
      user_name
      role
      id
      section_1_completed_date
      surveys {
        id
        title
        survey_type
        section_2_completed_date
        section_3_completed_date
        completed_date
      }
    }
  }
`